import { render, staticRenderFns } from "./BtnComprometerSelecionados.vue?vue&type=template&id=3e870154"
import script from "./BtnComprometerSelecionados.vue?vue&type=script&lang=js"
export * from "./BtnComprometerSelecionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports